import initMK from '../_core/init.js';
import defineProp from '../_core/defineprop.js';
import getNodes from './_getnodes.js';
import createBindingSwitcher from './_createbindingswitcher.js';
import bindSingleNode from './_bindsinglenode.js';
import forEach from '../_helpers/foreach.js';
import matreshkaError from '../_helpers/matreshkaerror.js';
import addTreeListener from '../on/_addtreelistener.js';
import { uniqueNodes } from '../_dom/index.js';
import deepBindings from './_deepbindings.js';
// binds one key (a path when it has dots) to its nodes: bindNode's other forms come down to this, and the parsers
// call it with keys they read from the DOM
export default function bindKey(object, key, node, binder, eventOptions, optionalFlag) {
  var _propDef$bindings$len, _propDef$bindings;
  if (eventOptions === void 0) {
    eventOptions = {};
  }
  if (optionalFlag === void 0) {
    optionalFlag = false;
  }
  if (!key) {
    throw matreshkaError('binding:falsy_key');
  }
  initMK(object);
  binder = binder || {};
  var _eventOptions = eventOptions,
    _eventOptions$optiona = _eventOptions.optional,
    optional = _eventOptions$optiona === void 0 ? optionalFlag : _eventOptions$optiona,
    _eventOptions$exactKe = _eventOptions.exactKey,
    exactKey = _eventOptions$exactKe === void 0 ? false : _eventOptions$exactKe;
  var $nodes = getNodes(object, node);
  // check node existence
  if (!$nodes.length) {
    if (optional) {
      return object;
    }
    throw matreshkaError('binding:node_missing', {
      key: key,
      node: node
    });
  }
  if (!exactKey) {
    var deepPath = key.split('.');
    var deepPathLength = deepPath.length;
    if (deepPathLength > 1) {
      // handle binding when key arg includes dots (eg "a.b.c.d")
      var deepBinding = {
        key: key,
        deepPath: deepPath,
        $nodes: $nodes
      };
      var bindingSwitcher = createBindingSwitcher({
        object: object,
        deepBinding: deepBinding,
        binder: binder,
        eventOptions: eventOptions,
        bindKey: bindKey
      });
      deepBinding.bindingSwitcher = bindingSwitcher;
      if (!deepBindings.has(object)) {
        deepBindings.set(object, []);
      }
      deepBindings.get(object).push(deepBinding);
      addTreeListener(object, deepPath.slice(0, deepPathLength - 1), bindingSwitcher);
      bindingSwitcher();
      return object;
    }
  }
  var propDef = defineProp(object, key);
  // "sandbox" (and an array's "container") takes one node; checked before $nodes changes
  if ((key === 'sandbox' || object.isMatreshkaArray && key === 'container') && ((_propDef$bindings$len = (_propDef$bindings = propDef.bindings) == null ? void 0 : _propDef$bindings.length) != null ? _propDef$bindings$len : 0) + $nodes.length > 1) {
    throw matreshkaError('binding:magic_props_nodes_length');
  }
  if (object.isMatreshka) {
    var _$allNodes$key;
    // if an object is Matreshka instance then extend "$nodes" and "nodes" objects
    var $allNodes = object.$nodes,
      allNodes = object.nodes;
    if (!$allNodes || !allNodes) {
      throw matreshkaError('binding:instance_nodes_missing', {
        $nodes: $allNodes,
        nodes: allNodes
      });
    }
    $allNodes[key] = (_$allNodes$key = $allNodes[key]) != null && _$allNodes$key.length ? uniqueNodes($allNodes[key], $nodes) : $nodes;
    allNodes[key] = $allNodes[key][0];
  }
  // handle binding for every node separately
  forEach($nodes, function (oneNode) {
    return bindSingleNode(object, {
      $nodes: $nodes,
      node: oneNode,
      key: key,
      eventOptions: eventOptions,
      binder: binder,
      propDef: propDef
    });
  });
  return object;
}